export const ENVIRONMENT = { 
    API_URL: "https://sdw-2023-prd.up.railway.app/users/1"
}